import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Spinner from './spinner';

const BoxedItem = (props) => {
  const contentClasses = classnames(
    'boxedItem',
    {
      'boxedItem--active': props.active,
      'boxedItem--with-icon': props.icon,
      'boxedItem--with-action': props.onClick,
    },
    props.className,
  );
  const noop = () => {};
  const onClickWrapper = (evt) => {
    // prevent propagation if the onclick has been fired
    // by an inner element and not the box itself
    const targetType = evt.target.getAttribute('type');
    const targetTag = evt.target.tagName;
    const isInputText = targetTag === 'INPUT' &&
      targetType === 'text';
    const isInputSubmitReset = targetTag === 'BUTTON' &&
      (targetType === 'submit' || targetType === 'reset');
    if (isInputText || isInputSubmitReset) {
      return;
    }
    // prevent multiple click while in loading state
    if (props.isLoading || !props.onClick) return;
    props.onClick();
  };
  return (
    <div className={contentClasses} onClick={onClickWrapper || noop}>
      <div className="boxedItem__header">
        <h5>{props.title}</h5>
        {props.subtitle &&
          <p>{props.subtitle}</p>
        }
      </div>
      <div className="boxedItem__content">
        <div>{props.children}</div>
      </div>
      {props.icon && !props.isLoading &&
        <i className={props.icon} />
      }
      {props.isLoading &&
        <Spinner />
      }
    </div>
  );
};

BoxedItem.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  active: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

BoxedItem.defaultProps = {
  isLoading: false,
  active: false,
};

export default BoxedItem;



// WEBPACK FOOTER //
// ./src/components/boxed-item.js